import { useEffect, useState } from 'react';

const useInfiniteScroll = (callback, tableRef) => {
  const [isFetching, setIsFetching] = useState(false);
  let timer = null;
  const handleScroll = event => {
    const tBody = event.target;
    if (tBody.scrollTop < tBody.scrollHeight - 600 || isFetching) return;
    setIsFetching(true);
  };

  useEffect(() => {
    timer = setTimeout(() => {
      tableRef?.current?.addEventListener('scroll', handleScroll);
    }, 0);
    return () => {
      tableRef?.current?.removeEventListener('scroll', handleScroll);
      window.clearTimeout(timer);
    };
  });

  useEffect(() => {
    if (!isFetching) return;
    callback();
  }, [isFetching]);

  return [setIsFetching];
};

export default useInfiniteScroll;
